module.exports = __webpack_public_path__ + "img/takeaway.234d5cad.svg";